import type {Room} from 'matrix-js-sdk';
import {isServiceParticipant} from '../../../utils/aiBotUtils';
import {isOneToOneRoom} from './roomCallEntry';

export const isOneToOneCallRoom = (room: Pick<Room, 'getJoinedMembers'>, isDirect: boolean): boolean =>
    isOneToOneRoom({
        isDirect,
        joinedHumanMembers: room.getJoinedMembers().filter(member => !isServiceParticipant(member.userId)).length,
    });
